if(!customElements.get('bundle-builder')) {
  class BundleBuilder extends HTMLElement {
  	constructor() {
      super();

      var paramPreselectedIds = $s.getQueryParam('products');
      var paramBundleId = $s.getQueryParam('bundle-id');

      var config = {
        bundleContainer: this, //bundle box selector
        items: document.querySelectorAll(this.dataset.itemsSelector), //items selector,
        bundleMinItems: parseInt(this.dataset.bundleMinItems), //global minimum required quantity of items in the bundle
        bundleMaxItems: parseInt(this.dataset.bundleMaxItems), //global limit of items in the bundle, 0=no limit
        groupItems: this.dataset.groupItems=='true', // true, or false to view 1 unit item,
        cartBundleMode: this.dataset.cartBundleMode, // "grouped" or "individual",
        showItemsPlaceholder: this.dataset.showItemsPlaceholder=='true',
        stepsContainer: document.querySelector(this.dataset.stepsContainerSelector),
        enableSource: this.dataset.enableSource == 'true'
      }
      //nav & panels behavior
      var btnNavClickHandler = ()=>{};
      if (config.stepsContainer.dataset.navMode == 'step_by_step' || config.stepsContainer.dataset.navMode == 'show_tabs' ) {
        btnNavClickHandler = function() {
          var switchPanel = true;
          var oldActiveButton = config.stepsContainer.querySelector('.step-nav.active');
          var oldActiveStep = oldActiveButton.dataset.step/1;
          var newStep = this.dataset.step/1;
          if (this.classList.contains('active')) {
            //don't switch if it is the active panel;
            switchPanel = false;
          }
          if (switchPanel) {
            var oldActivePanel = config.stepsContainer.querySelector('.step.active');
            var newActivePanel = config.stepsContainer.querySelector('.step[data-step="'+newStep+'"]');
            oldActiveButton.classList.remove('active');
            oldActivePanel.classList.remove('active');
            this.classList.add('active');
            newActivePanel.classList.add('active');
            $s.scrollToElement(newActivePanel, 60);
            setTimeout(() => newActivePanel.querySelector('.step-heading .title')?.focus(), 100)  
          }
        }
      } else {
        btnNavClickHandler = function(event) {
          var newStep = this.dataset.step/1;
          var newActivePanel = config.stepsContainer.querySelector('.step[data-step="'+newStep+'"]');
          $s.scrollToElement(newActivePanel, 60);
          setTimeout(() => newActivePanel.querySelector('.step-heading .title')?.focus(), 100)
          config.stepsContainer.querySelectorAll('.nav .step-nav').forEach(b => b.classList.remove('active'))
          event.currentTarget.classList.add('active')
        }
      }
      config.stepsContainer.querySelectorAll('.nav .step-nav').forEach(function(btn) {
        btn.addEventListener('click', btnNavClickHandler)
      });

      /* start of builder */
      var Bundler = (function(config) {
        var self = {};
        var container = config.bundleContainer;
        self.dataJson = JSON.parse(container.querySelector('[type="application/json"]').textContent);
        self.stats = {count: 0, total: 0, discount_code: '', incomplete_products_steps: self.dataJson.products_steps.map((x,key)=>key).filter(x=>x>0)};


        var itemsAdded = [];
        var uniqIndex = 1;

        // Start - Pre-load when editing bundle
        var variantToSteps = {};
        var productToSteps = {}
        // End - Pre-load when editing bundle

        var uniq = function() {
          return 'k-' + uniqIndex++;
        }
        var variantUnits = function(id, currentStep) {
          return itemsAdded.reduce((x,y)=>x + (id == y.variant_id && currentStep == y.step  ? y.quantity : 0), 0);
        }
        var productUnits = function(id, currentStep) {
          return itemsAdded.reduce((x,y)=>x + (id == y.product_id && currentStep == y.step ? y.quantity : 0), 0);
        }
        self.add = function(variantId, quantity, htmlItem) {
          var index = itemsAdded.map((x)=>x.variant_id).lastIndexOf(variantId);
          var item;
          if (config.groupItems && index != -1) {
            item = itemsAdded[index];
            item.quantity += quantity
          } else {
            var json = JSON.parse(htmlItem.querySelector('[type="application/json"][data-product-json]').textContent);
            
            item = {
              variant_id: variantId,
              quantity: quantity,
              key: uniq(),
              product_id: htmlItem.dataset.productId,
              title: htmlItem.querySelector('.product-subtitle').innerText,
              image: htmlItem.querySelector('.img.main').outerHTML,
              variant: json.variants.find((x)=>x.id==variantId),
              productData: json,
              step: htmlItem.step,
              accentColor: json.metafields.accentColor,
              backgroundColor: json.metafields.backgroundColor
            };
            itemsAdded.push(item);
          }
          self.drawItem(item);
          
        }
        self.remove = function(variantId, removeQuantity, currentStep) {
          var index = itemsAdded.map((x)=>{return currentStep==x.step ? x.variant_id : 0}).lastIndexOf(variantId);
          self.removeByIndex(index, removeQuantity);
        }
        self.removeByKey = function(key) {
          var index = itemsAdded.findIndex((x)=>x.key==key);
          var item = itemsAdded[index];
          self.removeByIndex(index, item.quantity);
        }
        self.removeByIndex = function(index, removeQuantity) {
          var item = itemsAdded[index];
          item.quantity -= removeQuantity;
          if (item.quantity == 0) {
            itemsAdded.splice(index, 1);
          }
          self.drawItem(item);
        }
        self.drawItem = function(item) {

          var itemsContainer = container.querySelector('.bundle-items');
          var html = `
            <div class="bundle-item" data-key="${item.key}" style="--product-accent-color: ${item.accentColor}; --product-background-color: ${item.backgroundColor};">
              <div class="flex">
                <div class="item-column col-image">
                  <div class="image">${item.image}</div>
                </div>
                <div class="item-column info flex-1">
                  <div class="title">${item.title}</div>
                  <div class="flex justify-content-between align-items-center">
                    <div class="flex price-quantity-wrapper">
                      <div class="price">
                        <span class="money">` + $s.formatMoney(item.variant.price) + `</span>
                      </div>
                      <div class="quantity ${item.quantity==1 ? `visually-hidden` : ``}">&nbsp;|&nbsp;Qty: <span class="count">${item.quantity}</span></div>
                    </div>
                  </div>
                  <div class="variant-title">${item.variant.option2 == null ? item.productData.options[0]: `Variant`}. ${item.variant.title}</div>
                </div>
                <div class="item-column col-remove">
                  <button class="remove" aria-label="Remove Item" title="Remove Item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M15.833 5.83333L15.1102 15.9521C15.0479 16.8243 14.3222 17.5 13.4478 17.5H6.55154C5.67714 17.5 4.95141 16.8243 4.88911 15.9521L4.16634 5.83333M8.33301 9.16667V14.1667M11.6663 9.16667V14.1667M12.4997 5.83333V3.33333C12.4997 2.8731 12.1266 2.5 11.6663 2.5H8.33301C7.87277 2.5 7.49967 2.8731 7.49967 3.33333V5.83333M3.33301 5.83333H16.6663" stroke="#323130" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            `;
          var existingItem = itemsContainer.querySelector('[data-key="' + item.key + '"]');
          if (item.quantity == 0) {
            html = '';
          }
          if (existingItem) {
            existingItem.outerHTML = html;
          } else {
            itemsContainer.insertAdjacentHTML("beforeend", html);
            
          }
          if (html != '') {
            itemsContainer.querySelector('.bundle-item[data-key="' + item.key + '"] .remove').addEventListener('click', function() {
              self.removeByKey(item.key);
            });
          }

          self.updateUI(item.step);
        }
        self.drawFormInputs = function() {
          //TODO Subscription updates here (replace variant_id, set subscription properties or selling plan value)
          var html = ''
          var bundleId = new Date().getTime() + '-' + Math.floor(Math.random()*9999 + 1000);

          //walk array in reverse order (then cart items order will match what user see in the bundler builder)
          for (var index = itemsAdded.length -1; index>=0; index--) {
            var item = itemsAdded[index];
            var mode = config.cartBundleMode == 'grouped' ? (index==0?'main' : 'related_multiple') : 'individual';
            html += `
              <input type="hidden" name="items[${index}][id]" value="${item.variant_id}">
              <input type="hidden" name="items[${index}][properties[_bundle_id]]" value="${bundleId}">
              <input type="hidden" name="items[${index}][properties[_bundle_item]]" value="${mode}">
              <input type="hidden" name="items[${index}][properties[_bundle_type]]" value="bundle_builder">
              <input type="hidden" name="items[${index}][quantity]" value="${item.quantity}">
              `;
              if (config.enableSource) {
                html += `
                  <input type="hidden" name="items[${index}][properties[_source]]" value="bundle">
                `;
              }
              if (config.cartBundleMode == 'grouped') {
                html += `
                <input type="hidden" name="items[${index}][properties[_locked]]" value="quantity">
                  `;
              }
              if (!config.groupItems) {
                html += `
                  <input type="hidden" name="items[${index}][properties[_bundle_position]]" value="${index + 1}">
                  `;
              }
          }
          container.querySelector('.form-inputs').innerHTML = html;
        }
        self.updateUI = function(currentStep) {
          //TODO Subscription updates here (show discounted price, don't change the variant id)
          var itemsContainer = container.querySelector('.bundle-items');
          var totalCount = itemsAdded.reduce((x,y)=>x + y.quantity, 0);
          var totalPrice = itemsAdded.reduce((x,y)=>x + y.variant.price * y.quantity, 0);
          self.stats.count = totalCount;
          self.stats.total = totalPrice;
          self.stats.discounted_price = '';


          self.dataJson.products_steps.forEach(function(pd_step, stepIx) {
            var currentStep = stepIx + 1;
            var stepConfig = self.dataJson.products_steps[stepIx];
            var stepContainter = config.stepsContainer.querySelector('.step[data-step="'+currentStep+'"]')
            //var itemsAddedFromStep = itemsAdded.filter(x=>x.step==currentStep);
            //var totalCountInStep = itemsAddedFromStep.reduce((x,y)=>x + y.quantity, 0);

            // Start - Pre-load when editing bundle, based on variants and products in step
            var itemsAddedFromStep = itemsAdded.filter(function(x) {
              var vid = String(x.variant_id);
              var pid = String(x.product_id);

              var variantSteps = variantToSteps[vid];
              var productSteps = productToSteps[pid];

              if (variantSteps && variantSteps.has(currentStep)) return true;
              if (productSteps && productSteps.has(currentStep)) return true;

              return x.step == currentStep;
            });
            // End - Pre-load when editing bundle

            var totalCountInStep = itemsAddedFromStep.reduce((sum, y) => sum + y.quantity, 0);

            if (stepContainter) {
              stepContainter.querySelectorAll('.selected-quantity').forEach(x=>x.innerHTML = totalCountInStep);
            }

            var incompleteStepsItemIndex = self.stats.incomplete_products_steps.indexOf(currentStep);
            if (stepConfig.min_items > 0 && totalCountInStep < stepConfig.min_items) {
              if (incompleteStepsItemIndex==-1) {
                self.stats.incomplete_products_steps.push(currentStep);
              }
            } else if (incompleteStepsItemIndex > -1) {
              self.stats.incomplete_products_steps.splice(incompleteStepsItemIndex, 1);
            }

            config.items.forEach(function(item) {
              if (item.step!=currentStep) {
                return;
              }
              //update number in quantity box (useful when removing items with the X)
              var currentVariantId = item.querySelector('[data-variant-id]').value;
              var currentVariantUnits = variantUnits(currentVariantId, currentStep);
              item.querySelector('input[type="number"]').value = currentVariantUnits;

              //disable/enable MINUS button
              item.querySelectorAll('.quantity-button.minus').forEach(function(element) {
                if (item.querySelector('[type="number"]').value == 0) {
                  element.setAttribute('disabled', true);
                } else {
                  element.removeAttribute('disabled');
                }
              });
              
              //disable/enable PLUS and ADD buttons
              /*
              item.querySelectorAll('.quantity-button.plus, .btn.add').forEach(function(element) {
                var variantInput = item.querySelector('[data-variant-id]')
                var productId = item.dataset.productId;
                if ( (config.bundleMaxItems > 0 && totalCount>=config.bundleMaxItems)
                  || (stepConfig.max_items > 0 && totalCountInStep>=stepConfig.max_items)
                  || (stepConfig.item_limit > 0 && variantUnits(variantInput.value, currentStep) >= stepConfig.item_limit)
                  || (stepConfig.product_limit > 0 && productUnits(productId, currentStep) >= stepConfig.product_limit) ) {
                  element.setAttribute('disabled', true);
                } else {
                  element.removeAttribute('disabled');
                }
              });
              */

              // Start - Pre-load when editing bundle 
              item.querySelectorAll('.quantity-button.plus, .btn.add').forEach(function(element) {
                var variantInput = item.querySelector('[data-variant-id]');
                var productId = item.dataset.productId;

                var globalVariantUnits = itemsAdded
                  .filter(x => String(x.variant_id) === String(variantInput.value))
                  .reduce((s, x) => s + x.quantity, 0);

                var globalProductUnits = itemsAdded
                  .filter(x => String(x.product_id) === String(productId))
                  .reduce((s, x) => s + x.quantity, 0);

                var disable = false;

                if (config.bundleMaxItems > 0 && totalCount >= config.bundleMaxItems) {
                  disable = true;
                }
                if (stepConfig.max_items > 0 && totalCountInStep >= stepConfig.max_items) {
                  disable = true;
                }
                if (stepConfig.item_limit > 0 && globalVariantUnits >= stepConfig.item_limit) {
                  disable = true;
                }
                if (stepConfig.product_limit > 0 && globalProductUnits >= stepConfig.product_limit) {
                  disable = true;
                }

                if (disable) {
                  element.setAttribute('disabled', true);
                } else {
                  element.removeAttribute('disabled');
                }
              });
              // End - Pre-load when editing bundle 
            });
          });
          
          //item placeholders
          if (config.showItemsPlaceholder) {
            itemsContainer.querySelectorAll('.item-placeholder').forEach(function(element) {
              element.parentNode.removeChild(element);
            });
            if (config.bundleMinItems > itemsAdded.length) {
              var placeholder = `
                <div class="bundle-item item-placeholder">
                  <div class="grid">
                    <div class="grid-item one-quarter"><div class="image-placeholder"></div></div>
                    <div class="grid-item three-quarters"><div class="info-placeholder"></div></div>
                  </div>
                </div>
                `.repeat(config.bundleMinItems - itemsAdded.length);
              itemsContainer.insertAdjacentHTML('beforeend', placeholder);
            }
          }


          //disable/enable ADD BUNDLE TO CART button if conditions not meet
          var enableAddBundle = true;
          if (self.stats.incomplete_products_steps.length > 0 || (config.bundleMinItems > 0 && totalCount < config.bundleMinItems)) {
            enableAddBundle = false;
          }
          if (enableAddBundle) {
            container.querySelector('.btn.add').removeAttribute('disabled');
          } else {
            container.querySelector('.btn.add').setAttribute('disabled', true);
          }


          //disable/enable step nav buttons after a step not completed
          if (config.stepsContainer.dataset.navMode == 'step_by_step') {
            var firstStepIncomplete = null;
            if (self.stats.incomplete_products_steps.length>0) {
              firstStepIncomplete = Math.min(...self.stats.incomplete_products_steps);
            }
            config.stepsContainer.querySelectorAll('.nav .step-nav').forEach(function(btn, ix) {
              if (firstStepIncomplete && ix+1 > firstStepIncomplete) {
                btn.setAttribute('disabled', true);
              } else {
                btn.removeAttribute('disabled');
              }
            });
          }


          self.updateProgress();
          
          container.querySelector('.count').innerHTML = totalCount;
          var finalPrice = self.stats.discounted_price ? self.stats.discounted_price : totalPrice;


          container.querySelector('.subtotal .price').innerHTML = `${
            self.stats.discounted_price ? 
            `
              <span class="retail money" id="subtotal-retail" aria-hidden="true">${$s.formatMoney(self.stats.total)}</span>
              <span class="visually-hidden">${container.querySelector('.subtotal').dataset.ariaLabelOriginalPrice}: ${$s.formatMoney(self.stats.total)}</span>
            ` : `` 
            }
            <span class="deal money" id="subtotal-deal" aria-hidden="true">${$s.formatMoney(finalPrice)}</span>
            <span class="visually-hidden">${self.stats.discounted_price ? `${container.querySelector('.subtotal').dataset.ariaLabelDiscountedPrice}:` : ''} ${$s.formatMoney(finalPrice)}</span>
            `;
          /*
          container.querySelector('.subtotal .price').innerHTML = `
            ` + (self.stats.discounted_price ? 
            `<span class="retail money">` + $s.formatMoney(self.stats.total) + `</span>` : ``) + `
              <span class="deal money">` + $s.formatMoney(finalPrice) + `</span>
            `;*/
        }

        self.updateProgress = function() {
          //progress bar UI
          
          if (self.dataJson.progress_steps.length > 0) {
            var steps = self.dataJson.progress_steps;
            var progressType = self.dataJson.progress_type;
            var currentValue = progressType == 'quantity' ? self.stats.count : self.stats.total/100;
            var values = steps.map((step)=>step.value);
            var maxValue = Math.max(...values);

            

            var progressLongValue = container.querySelector('.progress-value');
            var progressBars = container.querySelectorAll('.progress-bar');

            if (self.dataJson.progress_steps_independent) {
              progressBars.forEach(function(progressBar, ix) {
                var progressValue = progressBar.querySelector('.progress-value');
                var barValue = Math.min(currentValue / values[ix] * 100, 100);
                progressValue.style.width = barValue + '%';
                var dot = progressBar.querySelector('.progress-dot');
                if (barValue==100) {
                  dot.classList.add('completed');
                } else {
                  dot.classList.remove('completed');
                }
              });
            } else {
              var barValue = Math.min(currentValue / maxValue * 100, 100);
              progressLongValue.style.width = barValue + '%';
              progressBars.forEach(function(progressBar, ix) {
                progressBar.style.width = (values[ix] - (ix==0 ? 0 : values[ix-1]) ) / maxValue * 100 + '%';
                var dot = progressBar.querySelector('.progress-dot');
                if (values[ix]<=currentValue) {
                  dot.classList.add('completed');
                } else {
                  dot.classList.remove('completed');
                }
              });
            }

            var stepCompletedIndex = -1;
            for (var i = 0; i < steps.length; i++) {
              var step = steps[i];
              var caption = container.querySelector(`.progress-bar[data-progstep="${i+1}"] .caption-progress`);
              if (currentValue < step.value) {
                //next step
                var diff = step.value - currentValue;
                caption.innerHTML = caption.dataset.stepInProgress
                  .replace('[CURRENT_VALUE]', (progressType=='quantity' ? currentValue : $s.formatMoney(currentValue * 100)) )
                  .replace('[VALUE_REQUIRED]', (progressType=='quantity' ? diff : $s.formatMoney(diff * 100).replace('.00', '')) );
              } else {
                stepCompletedIndex = i;
                caption.innerHTML = caption.dataset.stepCompleted;
                self.stats.discount_code = step.discount_code || '';
                if (step.discount_percentage) {
                  self.stats.discounted_price = self.stats.total * (100 - step.discount_percentage) / 100;
                }
              }
            }            

          }
        }

        function cleanElements(){
         container.querySelectorAll('.bundle-items .bundle-item').forEach((e)=>{
            self.removeByKey(e.dataset.key)
         })
        }

        function init() {
          container.querySelector('.btn.add').addEventListener('click', function() {
            var add = async () => {
              self.drawFormInputs();
              var data = new FormData();
              container.querySelector('.form-inputs').querySelectorAll('[name]:checked,[name]:not([type="checkbox"]):not([type="radio"])').forEach(x=>data.append(x.name, x.value));

              async function addNewBundle(){
                await $s.post({
                  url: '/cart/add.js',
                  data: data,
                  success: function(){
                    $s.addToCartSuccess();
                    cleanElements();

                    if (paramBundleId) {
                      // Remove bundle id parameter if bundle was edited
                      const url = new URL(window.location);
                      url.searchParams.delete('bundle-id');
                      window.history.replaceState({}, document.title, url.toString());
                    }
                  },
                  error: function(response){
                    $s.addToCartFail(response.description);
                    console.error('Error adding new bundle', response);
                  }
                });
              }

              // Editing bundle builder
              if (paramBundleId) {
                $s.showOverlay();

                const updates = {};

                await $s.get({
                  url: '/cart.js',
                  success: function(cart) {
                    const parsedCart = JSON.parse(cart)
                    parsedCart.items.forEach(item => {
                      if(item.properties && item.properties['_bundle_id'] == paramBundleId) {
                        updates[item.key] = 0;
                      }
                    });
                  }
                });

                await $s.post({
                  url: '/cart/update.js',
                  data: { updates },
                  success: function(){
                    console.log('Removed previous bundle items');
                  },
                  error: function(response){
                    console.error('Error removing previous bundle', response);
                  }
                });

                addNewBundle();
              } else {
                addNewBundle();
              }
            }
            
            $s.showLoadingOverlay();

            if (self.stats.discount_code) {
              $s.get({url: '/discount/'+self.stats.discount_code, success: add})
            } else {
              add();
            }
          });

          var expandButton = container.querySelector('.expand-button');

          expandButton.addEventListener('click', function() {
            var panel = container.querySelector('.medium-down--expandable');
            if (this.getAttribute('aria-expanded')=='false') {
              this.setAttribute('aria-expanded', 'true');
              this.setAttribute('aria-label', this.dataset.ariaExpandedLabel);
              $s.expand([panel]);
            } else {
              this.setAttribute('aria-expanded', 'false');
              this.setAttribute('aria-label', this.dataset.ariaCollapsedLabel);
              $s.collapse([panel]);
            }
          });

          config.items.forEach(function(item) {
            //Update input type number starting value and min="0" attribute
            var a = item.querySelector('.product-card-url');
            a.removeAttribute('href');
            var number = item.querySelector('input[type="number"');
            var variantInput = item.querySelector('input[data-variant-id]');
            var addBtn = item.querySelector('.btn.add');
            item.step = item.closest('[data-step]').dataset.step/1;
            var currentStep = item.step;

            // Start - Pre-load when editing bundle
            var variantInputEl = item.querySelector('[data-variant-id]');
            if (variantInputEl) {
              var vid = String(variantInputEl.value);
              variantToSteps[vid] = variantToSteps[vid] || new Set();
              variantToSteps[vid].add(item.step);
            }

            var pid = String(item.dataset.productId);
            productToSteps[pid] = productToSteps[pid] || new Set();
            productToSteps[pid].add(item.step);
            // End - Pre-load when editing bundle

            var stepConfig = self.dataJson.products_steps[currentStep-1];

            number.setAttribute('min', '0');
            number.value = 0;
            number.setAttribute('disabled', true);
            if (stepConfig.item_limit) {
              number.setAttribute('max', stepConfig.item_limit);
            }

            //Handle quantity change
            number.addEventListener('change', function(event) {
              var diff = this.value - variantUnits(variantInput.value, currentStep);
              if (diff > 0) {
                self.add(variantInput.value, diff, item);
              } else if (diff < 0) {
                self.remove(variantInput.value, Math.abs(diff), item.step);
              }
            });

            //Handle swatch change
            variantInput.addEventListener('change', function(event) {
              number.value = variantUnits(variantInput.value, currentStep);
              self.updateUI(currentStep);
            });

            //clear existing events and replace button
            var btnDisplay = addBtn.style.display;
            
            addBtn.outerHTML = `<button type="button" class="btn add v2" style="display: none">Add to Bundle +</button>`;
            //update internal reference;
            addBtn = item.querySelector('.btn.add');
            addBtn.style.display = btnDisplay;
            addBtn.addEventListener('click', function() {
              self.add(variantInput.value, 1, item);
              number.value = variantUnits(variantInput.value, currentStep);
              self.updateUI(currentStep);
            });

        
          })

          self.updateUI(1);
        }
        
        init();

        return self;
      })(config);

      if(paramPreselectedIds){
        var preselectedIds = paramPreselectedIds.split(',');
        preselectedIds.forEach(itemId => {
          const htmlItem = Array.from(config.items).find(element => element.dataset.productId == itemId || element.querySelector('[data-variant-id]').value == itemId);
          if (htmlItem && !htmlItem.querySelector('.btn.add').disabled) {
            var variantId = htmlItem.querySelector('[data-variant-id]').value;
            Bundler.add(variantId, 1, htmlItem);
          }
        });
      }

      // Populate bundle if editing bundle
      if (paramBundleId) {
        function getCartItemsFromScriptTag() {
          const element = document.getElementById('cart-json');
          if (!element) return null;

          try {
            return JSON.parse(element.textContent);
          } catch (e) {
            console.error('Error:', e);
            return null;
          }
        }

        const cartData = getCartItemsFromScriptTag();

        if (cartData) {
          const bundleItems = cartData.filter(item => item.properties && item.properties['_bundle_id'] == paramBundleId);
  
          bundleItems.forEach(cartItem => {
            const htmlItem = Array.from(config.items).find(element => element.dataset.productId == cartItem.product_id || element.querySelector('[data-variant-id]').value == cartItem.variant_id);
  
            if (htmlItem) {
              Bundler.add(cartItem.variant_id, cartItem.quantity, htmlItem);
            }
          });
  
          //Bundler.updateUI(1);
          Bundler.dataJson.products_steps.forEach((productStep, stepIx) => {
            Bundler.updateUI(stepIx + 1);
          })
        } else {
          console.error('Error editing bundle');
        }
      }
    }
  }
  customElements.define('bundle-builder', BundleBuilder);
}
